import React from 'react';
import BaseComponent from "../../../baseComponent.js";
import CheckBox from "../../../../components/common/check-box/checkBox.jsx"
import { defaultDateFormat, defaultDateTimeFormat, defaultTimeFormat } from "../../../../core/constants/defaultValues"
import { variableTypes } from "./constants";

const moment = require('moment-timezone');
import styles from './variable.scss';

export class Selection extends BaseComponent {
  constructor(props) {
    super(props);
  }

  handleChange(field, value) {
    this.props.onFieldChange(this.props.selectionIndex, field, value);
  }

  handleVariableValueChange(variableIndex, value) {
    this.props.onVariableValueChange(this.props.selectionIndex, variableIndex, value);
  }

  handleValueChange(variableIndex, variable, value) {
    const getVariable = this.props.getVariable(variable.id);
    switch (getVariable.type) {
      case variableTypes.BOOLEAN: {
        if (value === "1") {
          value = true;
        }

        if (value === "0") {
          value = false;
        }

        if (value === "true" || value === "false") {
          value = JSON.parse(value);
        }
        break;
      }
    }

    this.props.onVariableValueChange(this.props.selectionIndex, variableIndex, value)
  }

  renderVariableValueInput(variableIndex, selectionVariable) {
    const dashboardVariable = this.props.getVariable(selectionVariable.id);
    const variableType = dashboardVariable.type;
    const dateFormat = selectionVariable.dateTimeFormat || defaultDateFormat;
    const dateTimeFormat = selectionVariable.dateTimeFormat || defaultDateTimeFormat;
    switch (variableType) {
      case variableTypes.DATE: {
        selectionVariable.value = moment(selectionVariable.value);
        return <div
          onClick={(e) => this.props.editDate(e, this.props.selectionIndex, selectionVariable)}>{selectionVariable.value.format(dashboardVariable.dateTimeFormat || defaultDateFormat)}</div>;
      }
      case variableTypes.DATETIME: {
        selectionVariable.value = moment(selectionVariable.value).tz(selectionVariable.timezone);
        return <div
          onClick={(e) => this.props.editDateTime(e, this.props.selectionIndex, selectionVariable)}>{selectionVariable.value.format(dashboardVariable.dateTimeFormat || defulatDateFormat)}</div>;
      }
      case variableTypes.TIME: {
        selectionVariable.value = moment(selectionVariable.value).tz(selectionVariable.timezone);
        return <div
          onClick={(e) => this.props.editTime(e, this.props.selectionIndex, selectionVariable)}>{selectionVariable.value.format(dashboardVariable.dateTimeFormat || defaultTimeFormat)}</div>;
        }

      default: {
        const value = variableType === variableTypes.EXPRESSION ? selectionVariable.expression : selectionVariable.value;
        return <input type={variableType === variableTypes.NUMBER ? "number" : "text"} className={styles.input} value={value}
          placeholder="Enter value"
          onChange={e => this.handleValueChange(variableIndex, selectionVariable, e.target.value)} />;
      }
    }
  }

  render() {
    const selection = this.props.selection;
    const variableValueCell = selection.variables.map((v, i) => {
      return <td key={i}>
        {this.renderVariableValueInput(i, v)}
      </td>;
    });
    return (
      <tr className={styles.row}>
        <td className={styles.check}>
          <CheckBox value={selection.isDefault}
            onChange={(value) => this.handleChange("isDefault", value)} />
        </td>
        <td>
          <input type="text" className={styles.input} value={selection.description}
            placeholder="Enter description"
            onChange={(e) => this.handleChange("description", e.target.value)} />
        </td>
        {variableValueCell}
        <td className={styles.remove}>
          <div>
            <i className="material-icons"
              onClick={() => this.props.onRemove(this.props.selectionIndex)}>remove_circle_outline</i>
          </div>
        </td>
      </tr>
    );
  }
}

Selection.contextTypes = {
  selection: React.PropTypes.object,
  onRemove: React.PropTypes.func,
  onFieldChange: React.PropTypes.func,
  index: React.PropTypes.number
};



// WEBPACK FOOTER //
// ./src/components/dashboard/control-widget/selection-contorl/selection.jsx